class ContestRegionEntries extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.querySelectorAll('[data-contest-carousel]').forEach((carousel) => this.update(carousel, 0));
    this.addEventListener('click', (event) => this.onClick(event), { signal });
    this.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
    this.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
    this.addEventListener('pointercancel', () => { this.gesture = null; }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  onClick(event) {
    const control = event.target.closest('[data-carousel-previous], [data-carousel-next], [data-carousel-dot]');
    if (!control || !this.contains(control)) return;
    const carousel = control.closest('[data-contest-carousel]');
    if (!carousel) return;
    const current = Number(carousel.dataset.index || 0);
    if (control.hasAttribute('data-carousel-previous')) this.update(carousel, current - 1);
    else if (control.hasAttribute('data-carousel-next')) this.update(carousel, current + 1);
    else this.update(carousel, Number(control.dataset.carouselDot));
  }

  onPointerDown(event) {
    const viewport = event.target.closest('[data-carousel-viewport]');
    if (!viewport || !this.contains(viewport) || event.button !== 0) return;
    this.gesture = {
      carousel: viewport.closest('[data-contest-carousel]'),
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
    };
  }

  onPointerUp(event) {
    if (!this.gesture || this.gesture.pointerId !== event.pointerId) return;
    const { carousel, x, y } = this.gesture;
    this.gesture = null;
    if (!carousel) return;
    const deltaX = event.clientX - x;
    const deltaY = event.clientY - y;
    if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    const current = Number(carousel.dataset.index || 0);
    this.update(carousel, current + (deltaX < 0 ? 1 : -1));
  }

  update(carousel, requestedIndex) {
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    if (!slides.length) return;
    const index = (requestedIndex + slides.length) % slides.length;
    const track = carousel.querySelector('[data-carousel-track]');
    const school = carousel.dataset.school || 'this school';
    carousel.dataset.index = String(index);
    if (track) track.style.transform = `translateX(-${index * 100}%)`;

    slides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });
    carousel.querySelectorAll('[data-carousel-dot]').forEach((dot, dotIndex) => {
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    const status = carousel.querySelector('[data-carousel-status]');
    if (status) status.textContent = `Image ${index + 1} of ${slides.length} for ${school}`;
  }
}

if (!customElements.get('contest-region-entries')) {
  customElements.define('contest-region-entries', ContestRegionEntries);
}
